import React from "react";
import checkIcon from "../svgIcons/Check";
import alertIcon from "../svgIcons/Alert";
export const TwoSectionWithTitleCard = ({ title, items, iconType }) => (React.createElement("div", { className: "two-section-with-title-card-root" },
    React.createElement("h4", null, title),
    React.createElement("div", { className: "two-section-with-title-card-root__contentWrapper" }, items && items.map((a, i) => (React.createElement("div", { key: `unique${i}`, className: "two-section-with-title-card-root__contentWrapper__content" },
        iconType === "check" ? React.createElement(React.Fragment, null, checkIcon({})) : (iconType === "alert" ? React.createElement(React.Fragment, null, alertIcon()) : ""),
        React.createElement("h5", null, a)))))));
